export default __webpack_public_path__ + "static/media/MarketBlack.7766d6da.svg";